<dialog-draggable-header>Files</dialog-draggable-header>

<div class="container">
   <div class="row flex-nowrap">
      <div class="col-auto px-0">
         <p-tree [value]="folders" selectionMode="checkbox" [selection]="selection" [propagateSelectionUp]="false"
            [propagateSelectionDown]="false" (onNodeSelect)="onTreeSelectionChange($event)"
            (onNodeUnselect)="onTreeSelectionChange($event)">
         </p-tree>
      </div>
      <div class="col px-2">
         <div class="h-100">
            <data-table #tprShowFilesTable [data]="files" [columns]="columns" (select)="onGridSelectionChange($event)"
               [loading]="loading" [filterColumnDisplay]="false" [paging]="true" [pageSize]="pageOptions.size"
               [defaultSortField]="pageOptions.sort" [totalRecords]="total" [lazy]="true" [lazyLoadOnInit]="false"
               (lazyLoad)="onLazyLoad($event)" [multiselect]="true" (unSelect)="onUnSelect($event)">
               <ng-container actionStart featurePermission="tpr">
                  <button [disabled]="this.resourced" *ngIf="this.selection[0]?.data.id !== 'trashId'" mat-button
                     (keydown.enter)="onAddFilesClick()" (click)="onAddFilesClick()" matTooltip="Click to add files."
                     subFeaturePermission="fileEdit">
                     Add File(s)
                  </button>
                  <button [disabled]="this.resourced" *ngIf="this.selection[0]?.data.id === 'trashId'" mat-button
                     (keydown.enter)="restoreHandler()" (click)="restoreHandler()" matTooltip="Click to restore files."
                     subFeaturePermission="fileEdit">
                     Restore
                  </button>
                  <mat-divider *ngIf="this.selection[0]?.data.id === 'trashId'" vertical
                     class="action-bar-vertical-divider"></mat-divider>
                  <button [disabled]="this.resourced" *ngIf="this.selection[0]?.data.id === 'trashId'" mat-button
                     (keydown.enter)="removeHandler()" (click)="removeHandler()"
                     matTooltip="Click to delete permanently." subFeaturePermission="fileEdit">
                     Empty
                  </button>
                  <mat-divider *ngIf="this.selection[0]?.data.id !== 'trashId'" vertical
                     class="action-bar-vertical-divider"></mat-divider>
                  <button [disabled]="this.resourced" *ngIf="this.selection[0]?.data.id !== 'trashId'" mat-button
                     (keydown.enter)="trashHandler()" (click)="trashHandler()" [disabled]="!trashFilesEnabled()"
                     matTooltip="Click to delete and move the selected file to the trash folder."
                     subFeaturePermission="fileEdit">
                     Delete Files
                  </button>
                  <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
                  <mat-label class="mx-2 mb-1"> Checking Fixture No:
                     <span class="text-danger">{{this.data.fixtureNo}}</span>
                  </mat-label>
                  <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
                  <mat-label class="mx-2 mb-1"> Part No Lh or Single:
                     <span class="text-danger">{{this.data.partNumber}}</span>
                  </mat-label>
               </ng-container>
               <ng-container actionEnd>
                  <button [disabled]="this.resourced" mat-button class="mx-2" (keydown.enter)="onEmailClick()"
                     (click)="onEmailClick()" matTooltip="Click to send an e-mail to the supplier contact.">
                     Email
                  </button>
                  <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
                  <button mat-dialog-close mat-button>Close</button>
               </ng-container>
            </data-table>
         </div>
      </div>
   </div>
</div>